const anyDefaultConstants = {
  defaultRecommendedCourseIds: [62, 171, 172, 56, 174, 337, 122],
  defaultNewCourseIds: [377, 386, 117, 371, 341],
  defaultTopSaleCourseIds: [277, 174, 172, 73, 257, 53, 171],
  defaultSpecialCourseId: {},
  defaultSpecialCourseIdsInSubscription: {
    388: 306,
    385: 391,
    393: 391
  },
  defaultPaywallServiceId: 3012,
  defaultLinkQuiz: 'https://anyclass.com/landings/ff_school_up_lk_quiz',
  coursesForShowModalNewOffer: [388, 385, 393],
  coursesForHideModalNewOffer: [306, 391]
}

export default anyDefaultConstants
